import { createContext } from 'react';
export const BottomSheetContext = /*#__PURE__*/createContext(null);
export const BottomSheetProvider = BottomSheetContext.Provider;
//# sourceMappingURL=external.js.map